export default __webpack_public_path__ + "static/media/swimicon.3adb755f.svg";